function loadVMMV(config) {
  console.log('Loading VMMV script...', config);
  const script = document.createElement('script');
  script.src = window.vmmvScriptUrl;

  script.onload = () => {
    let vmapp = null;

    config.onClose = async () => {
      await vmapp.unmount();
    };
    /*
    config.onAddToBag = async (product) => {
      await vmapp.unmount();
      // TODO: Implement add to bag functionality
    }; */

    // Initialize the VMMV widget
    vmapp = new vmmv.VMWidgetApp();
    vmapp
      .setConfig(config)
      .then(() => vmapp.init())
      .then(async () => {
        // Tealium: report VMMV availability (Persol parity — po-components.checkUpcAvailability)
        try {
          if (typeof window.publish !== 'function' || !window.PUB_SUB_EVENTS?.VMMVAvailability) return;

          const upcs = (config.products || []).map((product) => product.upc).filter(Boolean);

          let browserSupported = 0;
          let upcSupported = 0;

          if (typeof vmapp.isBrowserSupported === 'function') {
            browserSupported = (await vmapp.isBrowserSupported()) ? 1 : 0;
          }

          if (upcs.length && typeof vmapp.isUPCSupported === 'function') {
            const upcAvailability = await vmapp.isUPCSupported(upcs);
            if (Object.values(upcAvailability || {}).some((response) => response?.available === true)) {
              upcSupported = 1;
            }
          }

          window.publish(window.PUB_SUB_EVENTS.VMMVAvailability, {
            Vm_IsUpcSupported: String(upcSupported),
            Vm_IsBrowserSupported: String(browserSupported),
            Vm_PageContext: 'PDP',
          });
        } catch (e) {
          console.warn('[Tealium] Unable to publish VMMV availability', e);
        }
      })
      .catch((e) => console.error('VMMV initialization error:', e));
  };

  document.body.appendChild(script);
}
